import * as React from "react";
import { MouseEvent } from "react";
import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { IDropdownAction } from "../../Dropdown/Dropdown";

export interface IToolButtonDropdownMenuProp {
    anchorEl: null | HTMLElement;
    actions: IDropdownAction[];
    onClose: () => void;
}

export const ToolButtonDropdownMenu = (props: IToolButtonDropdownMenuProp) => {
    const menuOpen = Boolean(props.anchorEl);

    const handleCloseMenu = () => {
        props.onClose();
    };

    const handleActionClick = (event: MouseEvent<HTMLElement>, action: IDropdownAction) => {
        if (!action) return;
        if (action.disabled) return;
        handleCloseMenu();
        action.onClick();
    };
        
    return (
        <Box onClick={(e) => e.stopPropagation() }>
            <Menu
                anchorEl={props.anchorEl}
                open={menuOpen}
                onClose={handleCloseMenu}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                {props.actions.map((action, index) => action.onClick && (
                    action.divider
                        ? <Divider key={`divider-${index}`} />
                        : (<MenuItem key={typeof action.title === "string" ? action.title : `divider-${index}`} onClick={(event) => handleActionClick(event, action)} disabled={action.disabled}>
                            {action.icon && <ListItemIcon>{action.icon}</ListItemIcon>}
                            <ListItemText>{action.title}</ListItemText>
                        </MenuItem>)
                ))}
            </Menu>
        </Box>
    );
};